import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ShowCategory from "../../../components/SuperAdmin/Category/ShowCategory";

export default withRouter(connect()(ShowCategory));
